exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".work-order-info-container[data-v-21335b40]{margin-bottom:100px;position:relative}.work-order-info-container .bottom-container[data-v-21335b40]{width:100%;padding:10px 20px;position:fixed;bottom:0;background:#fff}.work-order-info-container .bottom-container .export-button[data-v-21335b40]{height:40px;width:100%;font-size:16px}.work-order-info-container[data-v-21335b40]  .el-loading-mask .el-loading-spinner{top:100px !important}.file-container .file-name[data-v-21335b40]{display:block;font-size:1rem;line-height:2rem;margin-bottom:20px}.file-container .el-button[data-v-21335b40]{height:35px;width:100%;font-size:16px}", ""]);

// exports
